import { render, staticRenderFns } from "./InventoryRefDialog.vue?vue&type=template&id=55768964&scoped=true"
import script from "./InventoryRefDialog.vue?vue&type=script&lang=js"
export * from "./InventoryRefDialog.vue?vue&type=script&lang=js"
import style0 from "./InventoryRefDialog.vue?vue&type=style&index=0&id=55768964&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55768964",
  null
  
)

export default component.exports